import { dbs } from "@/firebase/firestore"
// import { Document, DocumentOptionsNoMAP } from "../shared/document"
import { Document, DocumentOptionsNoMAP, DocumentOptions } from "./shared/document"

import { fieryBindings, fieryMapMutations } from "fiery-vuex"

const customersDB: any = dbs.customers

class Customer extends Document {
	first_name: String = ""
	last_name: String = ""
	email: String | null = null
	active: Boolean = false
	subscription_set: Boolean = false
	provisioned: Boolean = false
	status: String = 'Pending'
}

const CustomerOptions = {
	include: ["first_name", "last_name", 'email', 'company', "editableBy", "users", "managedBy", 'active', 'firm_id', 'status', 'subscription_set', 'provisioned', 'provision_error' ],
	extends: DocumentOptionsNoMAP,
	type: Customer
}

export default {
	namespaced: true,
	state: {
		current: {},
        customers: {},
        customers_a: []
	},
	mutations: {
		UPDATE_CUSTOMER(state, userID) {
			return state.current.update(userID)
		},
		SET_CUSTOMERS(state, getCustomers) {
			let customers = getCustomers()
            // console.log( 'SET_CUSTOMERS', [...customers] )
            state.customers = customers
            state.customers_a = Object.values( customers )
		},
		...fieryMapMutations({
			SET_CURRENT_CUSTOMER: "current"
			// 'SET_CUSTOMERS': 'customers'
		})
	},
	getters: {},
	actions: {
		...fieryBindings(
			{
				fetchCustomers( { state, rootState, dispatch, getters, rootGetters }, payload, $fiery ) {
					const options = {
						extends: CustomerOptions,
						query: q => q.where( "createdBy", "==", rootGetters.currentUserID )
                    }
					return $fiery(customersDB, options, "SET_CUSTOMERS")
				},
				fetchCustomer({ state, dispatch, commit }, customerID, $fiery) {
					// If ID was passed, set to that specific doc (it's an edit), otherwise use for a new document to create
					const customerDoc = customerID
						? customersDB.doc(customerID)
						: customersDB.doc()
					return $fiery(customerDoc, CustomerOptions, "SET_CURRENT_CUSTOMER")
				}
			},
			{ commitInitial: false }
		),
		async save({ state, dispatch, commit, rootState, rootGetters }, payload) {
			return state.current.update(rootGetters.currentUserID)
		},
		async remove({ state, commit }, customerID) {
			return state.customers[customerID]
				? state.customers[customerID].remove()
				: false
		}
	}
}
